import { FC } from 'react';

import { IMediaSection } from '../../models/i-media-section.interface';

import MediaItem from './mediaSlider/mediaItem/MediaItem';
import MediaSlider from './mediaSlider/MediaSlider';

const MediaSection: FC<IMediaSection> = ({ title, isVideo, data }) => (
  <>
    <h2 className="tw-pb-[30px] tw-pt-[20px] tw-text-center tw-text-[32px] tw-font-bold tw-uppercase tw-text-white sm:tw-pb-[60px] sm:tw-text-5xl">
      {title}
    </h2>
    <MediaSlider>
      {data.map((item) => (
        <MediaItem key={item.name} item={item} isVideo={isVideo} />
      ))}
    </MediaSlider>
  </>
);

export default MediaSection;
